<template>
    <div class="position-relative w-100">

        <div class="d-flex w-100 align-items-center">
            <div class="row w-100">

                <div class="col-md-6">

                    <div class="p-4 border-right">

                        <div class="form-group mb-0">

                            <label for="select-form">
                                Tested Space/Circuit:
                            </label>
                            <select v-model="form.data.space_id" class="form-control form-control-sm" id="select-form">
                                <option :value="null" disabled>Select...</option>
                                <option v-for="space in spaces"
                                        :value="space.id"
                                        v-text="space.name">
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="py-4 d-flex flex-column justify-content-between h-100">
                        <div>
                            <b>{{ form.untested_forms.length }} Sample Untested <span v-text="pluralize('Form', form.untested_forms.length)"></span></b>
                        </div>
                        <div>
                            <button @click="submit" class="btn btn-sm btn-primary">Save Changes</button>
                        </div>
                    </div>
                    <div class="d-flex" style="position:absolute; bottom: 1.5rem; right: 0px;">
                        <button class="btn btn-default btn-sm d-flex align-items-center justify-content-center"
                                style="width: 25px; height: 15px; border: 1px solid #dfdfdf"
                                @click="isShowingDetails = !isShowingDetails">
                            <i  class="fa fa-minus m-0" v-if="isShowingDetails"></i>
                            <i class="fa fa-xs fa-plus m-0" v-else></i>
                        </button>
                        <button type="button" @click="removeUntestedForm()" class="btn btn-danger btn-sm ml-2 d-flex align-items-center justify-content-center"
                                style="width: 25px; height: 15px">
                            <i class="fa fa-xs fa-trash m-0"></i>
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <div class="position-relative" :class="{'border border-danger' : form.errors.has('untested_forms') }">
<!--            <sample-untested-form-rows v-if="isShowingDetails" v-model="form"></sample-untested-form-rows>-->
            <sample-untested-form-rows v-if="isShowingDetails"
                                       :test="currentTest"
                                       v-model="form">
            </sample-untested-form-rows>
        </div>

    </div>
</template>
<script>
export default {

    props: ['project', 'demandResponse', 'test', 'spacesTaken', 'count', 'spaces'],

    data() {
        return {
            isShowingDetails: true,
            currentTest: this.test,
            form: new Form({
                id: this.demandResponse.id,
                untested_forms: this.test.untested_forms,
                data: {
                    space_id: this.test.space_id
                },
            }).dontClear()
        }
    },

    created() {
        // this.fetchSpaces()
    },

    methods: {

        submit() {
            this.form.patch(`/projects/${this.project.slug}/sample-demand-response-spaces`)
                .then(response => {
                    Toast.success('Changes saved successful.')
                    App.bus.$emit('refresh-groups', response.tests)
                })
                .catch(error => {
                    Toast.error(this.form.errors.first())
                })
        },

        removeUntestedForm() {
            if (this.form.id == null) {
                App.bus.$emit('remove-unexisting-form')
                return
            }
            App.request().delete(`/projects/${this.project.slug}/sample-untested-forms/${this.form.id}`)
                .then(response => {
                    Toast.success('Group removed successful.')
                    App.bus.$emit('refresh-groups', response.data.tests)
                })
                .catch(error => {

                })
        }
    },

    computed: {
        // selectedSpace() {
        //     if (!this.form.space_id) {
        //         return { forms: [] };
        //     }
        //
        //     return _.find(this.spaces, s => s.id == this.form.space_id)
        // },
        //
        //
        availableCircuits(){
            return _.filter(this.spaces, space => {
                console.log(space)
                // if(space.id == this.form.data.space_id) return true;
                // console.log(space)
                // return !this.spacesTaken.includes(form.test.id)
            })
        }
    }
}
</script>
